import { useSelector } from 'react-redux';
import { gatherItemsSelector } from './selectors';

export function useGatherItems() {
  return useSelector(gatherItemsSelector);
}
